var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.338c3.264 1.733 6.669 3.547 9.3 4.95l9.222-4.95A4367.01 4367.01 0 0 1 16.299 31C13.192 26.44 9.76 21.406 7 17.338zm.355-1.369 8.954-4.779 8.837 4.745-8.833 4.783-8.96-4.749zm8.944-6.31L7 14.556 16.258 1l9.264 13.586-9.223-4.926z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtc);
export default __webpack_public_path__ + "static/media/ETC.659d9934fb51054c6ec985c712b77366.svg";
export { ForwardRef as ReactComponent };